import React, { useState } from 'react'
import { useParams } from 'react-router'

// mui
import { Typography } from '@mui/material'

// collection
import PDFGenerator from './PDFGenerator/PDFGenerator.collection'

// wrapper
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper'

// gql
import { GET_JOB_DAY_INFO_FOR_PDF } from '../../../graphql/jobDay/jobDay.queries'

const SendReceipt = () => {
    const { jobDayId } = useParams()
    
    // ✅ FIX: Parse the ID to integer
    const parsedJobDayId = parseInt(jobDayId, 10)

    // ✅ Add validation
    if (isNaN(parsedJobDayId)) {
        return (
            <div>
                <Typography variant="h2">Customer Receipt</Typography>
                <Typography color="error">Invalid Job Day ID</Typography>
            </div>
        )
    }
    
    return (
        <div>
            <Typography variant="h2">Customer Receipt</Typography>

            {/* ✅ Use parsedJobDayId (integer) instead of jobDayId (string) */}
            <WithGqlQuery 
                component={PDFGenerator} 
                query={GET_JOB_DAY_INFO_FOR_PDF} 
                variables={{ id: parsedJobDayId }}  // ✅ Now it's an integer!
            />
        </div>
    )
}

export default SendReceipt
